// extracted by mini-css-extract-plugin
export var link = "index-module--link--pNJI3";
export var linkBiochip = "index-module--link-biochip--wfyUb";
export var linkTpsCovid19 = "index-module--link-tps-covid-19--hb4uK";
export var linkTps1 = "index-module--link-tps-1--f5Sh-";
export var linkBiochipImage = "index-module--link-biochip-image--lOc-z";
export var linkTps1Image = "index-module--link-tps-1-image--c1PJ6";
export var linkTpsCovid19Image = "index-module--link-tps-covid-19-image--kuI5K";
export var seeAlsoContent = "index-module--see-also-content--JpO2s";